<section>
    <!-- top  -->
    <section id="s-checkin" *ngIf="!isRefSPay">
        <div class="w-100 bgblue text-center py-3">
            <div class="container py-2">
                <div class="row">
                    <div class="col-12 text-center">
                        <img alt="Brand" src="assets/img/logo.svg" class="img img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- end top -->
    <section>
        <div class="bgmain content pb-4">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 mb-4 mt-5">
                        <div class="text-highlight text-center pt-3">Quý khách vui lòng liên hệ Nhân viên để được hỗ trợ.
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 mb-4">
                        <div class="text-result text-center"><img src="assets/img/support.png" alt="icon"
                                class="img-fluid"></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>